// extracted by mini-css-extract-plugin
export default {"menuBg":"#fff","menuText":"rgba(0,0,0,.4509803922)","menuActiveText":"#409eff"};